<div class="email-template container my-5">
  <div class="row align-items-center">
    <h2 class="text-left h3-tipografia-govco mb-0">
      {{ 'plantilla-correo.plantillas' | translate }}
    </h2>
    <p>{{ 'plantilla-correo.seleccione-plantilla' | translate }}</p>
  </div>

  <select [(ngModel)]="selectedTemplateId" (change)="onTemplateChange()">
    <option *ngFor="let template of templates" [value]="template.Id">
      {{ template.Nombre_plantilla }}
    </option>
  </select>

  <p class="variables-parrafo">
    {{ 'plantilla-correo.variables' | translate }}
    <span *ngIf="variablesArray.length > 0">
      {{ variablesArray.join(', ') }}
    </span>
  </p>

  <div #editorContainer class="jodit-container"></div>


  <div class="button-container">
    <button
      type="submit"
      (click)="saveTemplate()"
      class="btn-govco fill-btn-govco"
      aria-label="Guardar plantilla">
      {{ 'plantilla-correo.guardar' | translate }}
    </button>
  </div>
</div>
